import React from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

const decodeBase64 = (str) => {
  try {
    return decodeURIComponent(
      atob(str)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
  } catch (error) {
    console.error('Erro ao decodificar base64:', error);
    return '';
  }
};

const GoogleLoginButton = ({ onSuccess }) => {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID}>
      <GoogleLogin
        onSuccess={(credentialResponse) => {
          const jwt = credentialResponse.credential;

          const payload = jwt.split('.')[1];
          const decodedPayload = decodeBase64(payload); 
          const userInfo = JSON.parse(decodedPayload);

          if (onSuccess) {
            onSuccess(userInfo.name, userInfo.email);
          }
        }}
      />
    </GoogleOAuthProvider>
  );
};

export default GoogleLoginButton;